import { faUser } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function AqeedahCourseTeacher() {
  return (
    <section className="my-48">
      <div className="my-10 flex flex-col md:flex-row items-center md:items-start">
        <div className="justify-center">
          <p className="bg-green-100 p-5 rounded">
            <FontAwesomeIcon
              className="text-4xl text-green-600"
              icon={faUser}
            />
          </p>
        </div>
        <div className="px-2">
          <p className="font-bold ">কোর্স শিক্ষকঃ</p>
          <p className="text-xl text-green-600">
            শায়খ আব্দুল্লাহ আল বাকি (হাফি.)
          </p>
          <p>পরিচালক, আল হারামাইন ইসলামিক একাডেমি অনলাইন।</p>
          <p>
            দাঈ, ইসলামী দাওয়াহ এন্ড গাইডেন্স সেন্টার, পূর্ব জেদ্দা, সৌদি আরব।
          </p>
          <p className="mt-5">
            শায়খ দীর্ঘদিন যাবত দাওয়াতের সাথে যুক্ত আছেন, আল হামদুলিল্লাহ।
          </p>
          <p>
            তিনি বাংলাদেশে পড়াশোনা (দাওয়ায়ে হাদিস, কামিল (হাদিস বিভাগ)) শেষ করে
            আরব (সৌদি আরব, কুয়েত) আলেমদের কাছে পড়াশোনা করেছেন এবং আক্বীদাহর উপরে
            ডিপ্লোমা করেছেন।
          </p>
          <p className="mt-5">
            তিনি ঢাকায় ২ বছর এবং রংপুরে ৫ বছর শিক্ষকতা করেছেন।
          </p>
          <p>
            এছাড়াও দাওয়াতি কাজের অংশ হিসেবে কুয়েতি সংস্থায় (৫ বছর), জাপানে
            দাওয়াতি ট্যুর (১ মাস) সম্পন্ন করেছেন।
          </p>
          <p>
            তিনি গত ১২ বছর থেকে জেদ্দা ইসলামী দাওয়াহ সেন্টারে যোগ্যতার সাথে
            দাওয়াতি কাজের সাথে যুক্ত আছেন এবং অনলাইনে বিশ্বের বিভিন্ন প্রান্তে
            ছড়িয়ে থাকা বাঙালি ভাই-বোনদের মাঝে ইসলামের শিক্ষা ছড়িয়ে দিতে
            কার্যক্রম পরিচালনা করছেন।
          </p>
          <p className="mt-5">
            আল্লাহ সুবহানাহু ওয়া তায়ালা তাকে হায়াতে ত্বয়্যেবা দান করুন এবং তার
            ইলম ও আমলে বারাকাহ দান করুন। তার ত্যাগ, শ্রম ও কাজগুলো কবুল করুন।
            আমীন।
          </p>
        </div>
      </div>
    </section>
  );
}
